import {translation} from "./translation";
import {AfterViewInit, ChangeDetectorRef, Component, NgZone, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Router, RouterOutlet} from '@angular/router';
import {HymnFinderComponent} from "./hymn-finder/hymn-finder.component";
import {MatSidenav, MatSidenavModule} from "@angular/material/sidenav";
import {NgIf} from "@angular/common";
import {LayoutService} from "./service/layout.service";
import {SidenavService} from "./service/sidenav.service";
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";
import {ThemeService} from "./service/theme.service";
import {MatMenuModule} from "@angular/material/menu";
import {MatSliderModule} from "@angular/material/slider";
import {MidiPlayerService} from "./service/midi-player.service";
import {HymnSelectionService} from "./service/hymn-selection.service";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {FormsModule} from "@angular/forms";
import {ContinuousPlaybackService} from "./service/continuous-playback.service";
import {AutoScrollService} from "./service/auto-scroll.service";
import {MatSnackBar, MatSnackBarModule} from "@angular/material/snack-bar";
import {SettingsManagerComponent} from "./settings-manager/settings-manager.component";
import {SettingsService} from "./service/settings.service";
import {BackButtonService} from "./service/back-button.service";
import {InfoMessageService} from "./service/info-message.service";
import {DebuggerComponent} from "./controls/debugger/debugger.component";
import { Capacitor } from '@capacitor/core';
import { TextZoom } from '@capacitor/text-zoom';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    HymnFinderComponent,
    MatSidenavModule,
    NgIf,
    MatSidenavModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatSliderModule,
    MatCheckboxModule,
    FormsModule,
    MatSnackBarModule,
    SettingsManagerComponent,
    DebuggerComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  title = translation.title;

  @ViewChild('sidenavList') public sidenavList!: MatSidenav;
  @ViewChild('sidenavSettings') public sidenavSettings!: MatSidenav;

  safeAreaInsets: { top: number; right: number; bottom: number; left: number} = { top: 0, right: 0, bottom: 0, left: 0 };

  constructor(public layoutService: LayoutService,
              private sidenavService: SidenavService,
              private router: Router,
              public themeService: ThemeService,
              public midiPlayerService: MidiPlayerService,
              public hymnSelectionService: HymnSelectionService,
              public continuousPlaybackService: ContinuousPlaybackService,
              private zone: NgZone,
              private snackbar: MatSnackBar,
              public autoScrollService: AutoScrollService,
              protected settingService: SettingsService,
              private backButtonService: BackButtonService, // do not remove in order to keep the back button functionality
              private changeDetectorRef: ChangeDetectorRef,
              private infoMessageService: InfoMessageService) {
    sidenavService.sidenavState$.subscribe((isOpen: boolean) => {

      window.addEventListener('unhandledrejection', event => {
        console.error('🔥 UNHANDLED PROMISE REJECTION:', event.reason);
      });

      this.disableTextZoom();
      if(this.sidenavList) {
        if (isOpen) {
          this.zone.run(() => {
            this.sidenavList.open();
          });
        } else {
          this.zone.run(() => {
            this.sidenavList.close();
          });
        }
      }
    });
  }

  ngAfterViewInit(): void {
    this.router.events
      .subscribe(() => {
        if(document.querySelector('.mat-sidenav-content')) {
          document.querySelector('.mat-sidenav-content')!.scrollTop = 0;
        }
      });

    this.infoMessageService.checkForInfoMessage();
  }

  async ngOnInit() {
    this.layoutService.initSafeArea();

    this.settingService.settingsState$.subscribe((isOpen: boolean) => {
      if(this.sidenavSettings) {
        if (isOpen) {
          this.sidenavSettings.open();
        } else {
          this.sidenavSettings.close();
        }
      }
    });
  }

  // Disable text zoom on mobile platforms
  async disableTextZoom() {
    if (Capacitor.isNativePlatform()) {
      // The plugin uses a decimal value, where 1.0 is 100%
      await TextZoom.set({ value: 1.0 });
    }
  }

  ngOnDestroy(): void {
    this.autoScrollService.stopAutoScroll();
  }
}
